import LoginView from './views/authentication/Login.vue';
import ForgetView from './views/authentication/Forget.vue';
import SentView from './views/authentication/Sent.vue';
import TwofaView from './views/authentication/Twofa.vue';
// import RegistrationView from './views/authentication/Registration.vue';
import HomeView from './views/main/Home.vue';

/*user-management-start----------*/
import UserManagement from '@/views/main/pages/user-management/UserManagement.vue'
import UserIndex from '@/views/main/pages/user-management/index/UsersIndex.vue'
import UserCreate from '@/views/main/pages/user-management/create/UsersCreate.vue'
import UsersEdit from '@/views/main/pages/user-management/edit/UsersEdit.vue'
import PermissionsUpdate from '@/views/main/pages/user-management/permissions/PermissionsUpdate.vue'
/*user-management-end----------*/

/*user-profile-start----------*/
import ProfileUpdate from '@/views/main/pages/user-profile/index/Profile'
/*user-profile-end----------*/


/*branch-management-start----------*/
import BranchManagement from '@/views/main/pages/branch/BranchManagement'
import BranchIndex from '@/views/main/pages/branch/index/BranchIndex'
import BranchCreate from '@/views/main/pages/branch/create/CreateBranch'
import BranchEdit from '@/views/main/pages/branch/edit/BranchEdit'
/*branch-management-end----------*/

/*member-management-start----------*/
import MemberManagement from '@/views/main/pages/member/MemberManagement'
import MemberIndex from '@/views/main/pages/member/index/MemberIndex'
import MemberCreate from '@/views/main/pages/member/create/CreateMember'
import MemberEdit from '@/views/main/pages/member/edit/MemberEdit.vue'
import AccountCreate from '@/views/main/pages/member/accounts/create/AccountCreate.vue'
import AccountIndex from '@/views/main/pages/member/accounts/index/AccountIndex.vue'
import ImportFiles from '@/views/main/pages/member/imports/ImportFiles.vue'
import CreateAccountTypes from '@/views/main/pages/member/accounts/account-type/create/CreateAccountType'
import EditAccountType from '@/views/main/pages/member/accounts/account-type/edit/EditAccountType.vue'
import AccountTypeIndex from '@/views/main/pages/member/accounts/account-type/index/AccountTypeIndex.vue'
// import MemberView from '@/views/main/pages/member/view/MemberView.vue'
import MemberViewPage from '@/views/main/pages/member/view/MemberViewPage.vue'
/*member-management-start----------*/

/*chart-of-account-start----------*/
import ChartOfAccounts from '@/views/main/pages/finance/chart-of-accounts/ChartOfAccounts.vue'
import ChartOfAccountsIndex from "@/views/main/pages/finance/chart-of-accounts/index/ChartOfAccountsIndex.vue"
import AccountTypes from "@/views/main/pages/finance/account-types/index/AccountTypes.vue"
/*chart-of-account-end----------*/

/* insitution-management-start--------------- */
import InstitutionManagement from '@/views/main/pages/institution/InstitutionManagement.vue'
import InstitutionCreate from '@/views/main/pages/institution/create/InstitutionCreate.vue'
/* insitution-management-end--------------- */

/* financial-year-start--------------- */
import FinancialYearManagement from '@/views/main/pages/financial-year/FinancialYearManagement.vue'
import FinancialYear from '@/views/main/pages/financial-year/index/FinancialYearIndex.vue'
/* financial-year-end--------------- */

/* Loan ----------------------*/
import LoanManagement from '@/views/main/pages/loan/LoanManagement.vue'
import LoanApplication from '@/views/main/pages/loan/application/index/LoanApplication.vue'
import LoanCalculator from '@/views/main/pages/loan/calculator/index/LoanIndex.vue'
import AllLoanRepayments from '@/views/main/pages/loan/repayment/AllLoanRepayments.vue'
import LoanScheme from '@/views/main/pages/loan/scheme/index/LoanScheme.vue'
import SchemeCreate from '@/views/main/pages/loan/scheme/create/SchemeCreate.vue'
import SchemeEdit from '@/views/main/pages/loan/scheme/edit/SchemeEdit.vue'
import LoanIndex from '@/views/main/pages/loan/index/LoanIndex.vue'
import LoanMerge from '@/views/main/pages/loan/merge/LoanMerge.vue'

// import CreateLoanApplication from '@/views/main/pages/loan/loan-application/form/application/create/CreateApplication.vue'

/* Loan-calculator-end ----------------------*/

/* Transactions start -------------------------------*/
import TransactionManagement from '@/views/main/pages/transactions/TransactionManagement.vue'
import Deposit from '@/views/main/pages/transactions/deposit-withdrawal/Deposit.vue'
import Withdrawal from '@/views/main/pages/transactions/deposit-withdrawal/Withdrawal.vue'
// import DepositWithdrawal from '@/views/main/pages/transactions/deposit-withdrawal/DepositWithdrawal.vue'
// import DwView from '@/views/main/pages/transactions/deposit-withdrawal/view/DwView.vue';
// import BulkDeposits from '@/views/main/pages/transactions/bulk-deposit-withdrawal/BulkDeposits.vue'
import AllDepositWithdrawal from '@/views/main/pages/transactions/all-deposit-withdrawal/AllDepositWithdrawal.vue'
import TransactionImport from './views/main/pages/transactions/Import/ImportIndex.vue';
import ChequeProcessing from '@/views/main/pages/transactions/cheque-processing/ChequeProcessing.vue'
/* Transactions end -------------------------------*/

// Investment Start-----------------------------
import FixedDeposit from '@/views/main/pages/investment/fixed-deposit/FixedDeposit.vue'
// Investment End-----------------------------

// Standing Order Start-----------------------------
import StandingOrder from '@/views/main/pages/standing-order/StandingOrder.vue'
// Standing Order End-----------------------------

/* Voucher Start -------------------------------------*/
import VoucherManagement from '@/views/main/pages/voucher/VoucherManagement.vue'
import VoucherIndex from '@/views/main/pages/voucher/index/VoucherIndex.vue'
import VoucherCreate from '@/views/main/pages/voucher/create/VoucherCreate.vue'
import ApproveVoucher from '@/views/main/pages/voucher/forms/Approve.vue'
/* Voucher End -------------------------------------*/

/*Journal Start------------------------------------*/
import JournalManagement from '@/views/main/pages/journal/JournalManagement.vue'
import JournalIndex from '@/views/main/pages/journal/index/JournalIndex.vue'
import JournalCreate from '@/views/main/pages/journal/create/JournalCreate.vue'
import CreateOpeningAndClosingJournal from '@/views/main/pages/journal/create/CreateOpeningAndClosingJournal.vue'
import ApproveJournal from '@/views/main/pages/journal/forms/Approve.vue'
import JournalTransfer from './views/main/pages/journal/transfer/JournalTransfer.vue';
import JournalTransferCreate from './views/main/pages/journal/transfer/create/JournalTransferCreate.vue';

/* Voucher End -------------------------------------*/


/* Reports----------------------------------- */
import ReportsManagement from '@/views/main/pages/reports/ReportsManagement.vue'
import Reports from '@/views/main//pages/reports/Reports.vue'
// Controls -----------------------------------------------------
import DailyProductsCustomers from '@/views/main/pages/reports/controls/DailyProductsCustomers.vue'
import DailyProductsCustomersbyRo from '@/views/main/pages/reports/controls/DailyProductsCustomersbyRo.vue'
import CustomerControlBalance from '@/views/main/pages/reports/controls/CustomerControlBalance.vue'
import MemberStatisticReport from '@/views/main/pages/reports/controls/MemberStatisticReport.vue'
import ProductBalanceTerm from '@/views/main/pages/reports/controls/ProductBalanceTerm.vue'
import CustomerListing from '@/views/main/pages/reports/controls/CustomerListing.vue'
import Performance from '@/views/main/pages/reports/controls/Performance.vue'
// Loan -------------------------------------------------
import Aging from '@/views/main/pages/reports/loan/Aging.vue'
import LoanRepay from '@/views/main/pages/reports/loan/LoanRepay.vue';
import Delinquency from '@/views/main/pages/reports/loan/Delinquency.vue';
import OpenClose from '@/views/main/pages/reports/loan/OpenClose.vue';
import LoanDisbursed from '@/views/main/pages/reports/loan/LoanDisbursed.vue';
// import BulkRepaymentUpload from './views/main/pages/loan/bulk/BulkRepayment.vue';
import LoanImports from './views/main/pages/loan/imports/ImportFiles.vue';

//Financials
import DetailedPayment from './views/main/pages/reports/financials/DetailedPayment.vue';
import DetailedReceipt from './views/main/pages/reports/financials/DetailedReceipt.vue';
import TrialBalYearToDate from '@/views/main/pages/reports/financials/trial_balance/TrialBalYearToDate.vue'
import ChartOfAccountReport from '@/views/main/pages/reports/financials/ChartOfAccountReport.vue'
import SingleChartOfAccountReport from '@/views/main/pages/reports/financials/SingleChartOfAccountReport.vue'
import COAHeadsReport from '@/views/main/pages/reports/financials/COAHeadsReport.vue'
import IncomeStatement from './views/main/pages/reports/financials/IncomeStatement.vue';
import ReceiptsPayments from './views/main/pages/reports/financials/ReceiptsPayments.vue';
import IncomeStatementSummary from './views/main/pages/reports/financials/IncomeStatementSummary.vue';
import DetailedCustomerReceiptsReport from './views/main/pages/reports/financials/DetailedCustomerReceiptsReport.vue';
import DetailedCustomerPaymentsReport from './views/main/pages/reports/financials/DetailedCustomerPaymentsReport.vue';
// import BulkWithdrawals from './views/main/pages/transactions/bulk-deposit-withdrawal/BulkWithdrawals.vue';
import JournalReport from './views/main/pages/reports/financials/Journal';
import FixedTermDepositReport from './views/main/pages/reports/financials/FixedTermDepositReport.vue';
import FixedTermTransactionsReport from './views/main/pages/reports/financials/FixedTermTransactionsReport.vue';
import VoucherReport from './views/main/pages/reports/financials/Voucher';
import UserCoaTracker from './views/main/pages/reports/controls/UserCoaTransactionTracker.vue';
// import DetailedReceiptAndPayment from './views/main/pages/reports/financials/DetailedReceiptAndPayment.vue';

//Mobile
import MobileDeposit from './views/main/pages/transactions/mobile/Deposit.vue'
import MobileWithdrawal from './views/main/pages/transactions/mobile/Withdrawal.vue'
import MobileProfile from '@/views/main/pages/user-profile/index/MobileProfile'
import History from './views/main/pages/transactions/mobile/History';
import MobileMember from './views/main/pages/member/mobile/MobileMember';
import ExpectedLoanRepayments from './views/main/pages/reports/loan/ExpectedLoanRepayments.vue';
import COAImports from './views/main/pages/finance/imports/ImportFiles.vue';
import RegionsImport from './views/main/pages/branch/regions/RegionsImport.vue';
import AccountEdit from './views/main/pages/member/accounts/edit/AccountEdit.vue';
import FixedDepositScheme from './views/main/pages/investment/fd-scheme/index/FixedDepositScheme.vue';
import FdCreateScheme from './views/main/pages/investment/fd-scheme/create/FdCreateScheme.vue';
import FdEditScheme from './views/main/pages/investment/fd-scheme/edit/FdEditScheme.vue';
import Unauthorized from './views/main/Unauthorized.vue';
import AttendanceIndex from './views/main/pages/user-management/attendance/index/AttendanceIndex.vue';
import OperationImport from './views/main/pages/investment/imports/OperationImport.vue';

// API KEY route
import ApikeyIndex from './views/main/pages/apikey/index/ApikeyIndex.vue';
import ReceiptPaymentSummary from './views/main/pages/reports/financials/ReceiptPaymentSummary.vue';
import DetailedReceiptAndPayment from './views/main/pages/reports/financials/DetailedReceiptAndPayment.vue';
import ConsolidatedPerformance from './views/main/pages/reports/controls/ConsolidatedPerformance.vue';
import SingleConsolidatedPerformance from './views/main/pages/reports/controls/SingleConsolidatedPerformance.vue';
import SingleCommissionRoPaid from './views/main/pages/reports/controls/SingleCommissionRoPaid.vue';
import SingleCommissionRoExpected from './views/main/pages/reports/controls/SingleCommissionRoExpected.vue';
import MainAccountImport from './views/main/pages/member/accounts/imports/MainAccountImport.vue';
import Main from './views/main/pages/finance/reconcile-coa/Main.vue';
import MergeCOA from './views/main/pages/finance/merge-coa/MergeCOA.vue';
import CustomerBalanceDifferences from './views/main/pages/reports/controls/CustomerBalanceDifferences.vue';
// import JournalImport from './views/main/pages/journal/import/JournalImport.vue';
import AllLoanTransactions from './views/main/pages/loan/transactions/AllLoanTransactions.vue';
import AuditIndex from './views/main/pages/user-management/audit/AuditIndex.vue';
import RoCommissionSummary from './views/main/pages/reports/controls/RoCommissionSummary.vue';
import ImportPage from './views/main/pages/journal/import/ImportPage.vue';
import COATransaction from './views/main/pages/finance/coa-transactions/COATransaction.vue';
import LoanProduct from './views/main/pages/reports/loan/LoanProduct.vue';
import LoanDelinquentByProduct from './views/main/pages/reports/loan/LoanDelinquentByProduct.vue';
import LoanProductDetailed from './views/main/pages/reports/loan/LoanProductDetailed.vue';
// import JournalEdit from './views/main/pages/journal/edit/JournalEdit.vue';
import LoanAgingSummary from './views/main/pages/reports/loan/LoanAgingSummary.vue';
import FixedDepositTransactions from './views/main/pages/investment/fixed-deposit/transactions/FixedDepositTransactions.vue';
import RoTransfer from './views/main/pages/member/ro-transfer/RoTransfer.vue';
import ExcelExport from './views/main/pages/user-management/failed-excel/ExcelExport.vue';
import SmsIndex from './views/main/pages/sms/SmsIndex.vue';
import ReceiptPaymentDefaultSummary from './views/main/pages/reports/financials/ReceiptPaymentDefaultSummary.vue';
import ReceiptPaymentDefaultDetailed from './views/main/pages/reports/financials/ReceiptPaymentDefaultDetailed.vue';
import AllMembers from './views/main/pages/transactions/mobile/AllMembers.vue';
import OtherReceipt from './views/main/pages/transactions/mobile/OtherReceipt.vue';
import JournalEdit from './views/main/pages/journal/edit/JournalEdit.vue';
import BalanceSheetSummaryVertical from './views/main/pages/reports/financials/BalanceSheetSummaryVertical.vue';
import BalanceSheetSummaryHorizontal from './views/main/pages/reports/financials/BalanceSheetSummaryHorizontal.vue';
import BalanceSheetDetailedVertical from './views/main/pages/reports/financials/BalanceSheetDetailedVertical.vue';
import BalanceSheetDetailedHorizontal from './views/main/pages/reports/financials/BalanceSheetDetailedHorizontal.vue';
// import OtherPaymentReceipts from './views/main/pages/transactions/other-payment-receipts/OtherPaymentReceipts.vue';
import OtherReceiptPaymentIndex from './views/main/pages/other-receipt-payment/index/OtherReceiptPaymentIndex.vue';
import OtherReceiptPaymentManagement from './views/main/pages/other-receipt-payment/OtherReceiptPaymentManagement.vue';
import CreateOtherReceiptPayment from './views/main/pages/other-receipt-payment/create/CreateOtherReceiptPayment.vue';
import VoucherEdit from './views/main/pages/voucher/edit/VoucherEdit.vue';
import CustomerBirthday from './views/main/pages/reports/controls/CustomerBirthday.vue';
import DocumentUpload from './views/components/AI/DocumentUpload.vue';

//Statistic Reports
import AccountStatisticSystem from './views/main/pages/reports/statistics/AccountStatisticSystem.vue';
import AccountStatisticSystemSummary from './views/main/pages/reports/statistics/AccountStatisticSystemSummary.vue';
import AccountStatisticCUA from './views/main/pages/reports/statistics/AccountStatisticCUA.vue';
import AccountStatisticCUASummary from './views/main/pages/reports/statistics/AccountStatisticCUASummary.vue';
import CommissionTransfer from './views/main/pages/commission-transfer/CommissionTransfer.vue';
import LoanRepayment from './views/main/pages/loan/repayment/LoanRepayment.vue';


export default [{
    path: '/',
    component: HomeView
  },
  {
    path: '/login',
    component: LoginView,
    meta: {
      title: 'Login'
    }
  },
  // {
  //   path: '/register',
  //   component: RegistrationView
  // },
  {
    path: '/forget',
    component: ForgetView
  },
  {
    path: '/sent',
    component: SentView
  },
  {
    path: '/2fa',
    component: TwofaView
  },
  {
    path: "/users",
    component: UserManagement,
    children: [{
        path: "/users",
        name: "users.index",
        component: UserIndex,
        meta: {
          permission: 'user_management_view'
        } // Define the permission needed for this route
      },
      {
        path: "/users/create",
        name: "users.create",
        component: UserCreate,
        meta: {
          permission: 'user_management_add'
        }
      },
      {
        path: "/users/:id/edit",
        name: "users.edit",
        component: UsersEdit,
        meta: {
          permission: 'user_management_edit'
        }
      },
      {
        path: "/users/permissions",
        name: "users.permissions",
        component: PermissionsUpdate,
        meta: {
          permission: 'permission_management_edit'
        }
      },
      {
        path: "/users/profile",
        name: "users.profile",
        component: ProfileUpdate
      },
      {
        path: "/users/attendance",
        name: "users.attendance",
        component: AttendanceIndex
      },
      {
        path: "/users/audit",
        name: "users.audit",
        component: AuditIndex,
        meta: {
          permission: 'user_management_audit'
        }
      },
      // {
      //   path: "/branch",
      //   name: "branch.index",
      //   component: BranchIndex
      // },
      // {
      //   path: "/branch/create",
      //   name: "branch.create",
      //   component: BranchCreate
      // },
      // {
      //   path: "/settings/member",
      //   name: "setting.members",
      //   component: MemberIndex
      // },
      // {
      //   path: "/member/create",
      //   name: "members.create",
      //   component: MemberCreate
      // },

    ]
  },
  {
    path: "/branch",
    component: BranchManagement,
    children: [{
        path: "/branch",
        name: "branch.index",
        component: BranchIndex,
        meta: {
          permission: 'system_management_view_branch'
        }
      },
      {
        path: "/branch/create",
        name: "branch.create",
        component: BranchCreate,
        meta: {
          permission: 'system_management_add_branch'
        }
      },
      {
        path: "/branch/:id/edit",
        name: "branch.edit",
        component: BranchEdit,
        meta: {
          permission: 'system_management_edit_branch'
        }
      },
      {
        path: "/region/imports",
        name: "region.imports",
        component: RegionsImport
      },
    ]
  },
  {
    path: "/members",
    component: MemberManagement,
    children: [{
        path: "/members",
        name: "member.index",
        component: MemberIndex,
        meta: {
          permission: 'member_management_view'
        }
      },
      {
        path: "/members/create",
        name: "members.create",
        component: MemberCreate,
        meta: {
          permission: 'member_management_add'
        }
      },
      {
        path: "/members/:id/edit",
        name: "members.edit",
        component: MemberEdit,
        meta: {
          permission: 'member_management_edit'
        }
      },
      {
        path: "/members/account/create",
        name: "account.create",
        component: AccountCreate,
        meta: {
          permission: 'account_management_add'
        }
      },
      {
        path: "/members/account",
        name: "account.index",
        component: AccountIndex,
        meta: {
          permission: 'account_management_view'
        }

      },
      {
        path: "/members/import",
        name: "member.import",
        component: ImportFiles,
        meta: {
          permission: 'member_management_import'
        }
      },
      {
        path: "/members/account-type",
        name: "member.account-type",
        component: AccountTypeIndex,
      },
      {
        path: "/members/account-type/create",
        name: "member.account-type.create",
        component: CreateAccountTypes
      },
      {
        path: "/members/view/:id",
        name: "member.view",
        component: MemberViewPage,
        meta: {
          permission: 'member_management_view'
        }
      },
      {
        path: "/members/account-type/:id/edit",
        name: "memeber.edit",
        component: EditAccountType
      },
      {
        path: "/mobile/member",
        name: "mobile.member",
        component: MobileMember
      },
      {
        path: "/members/account/imports",
        name: "members.account.imports",
        component: MainAccountImport
      },
      {
        path: "/members/account/:id/edit",
        name: "members.account.edit",
        component: AccountEdit,
        meta: {
          permission: 'account_management_edit'
        }
      },
      {
        path: "/members/ro/transfer",
        name: "members.ro.transfer",
        component: RoTransfer,
        // meta: { permission: 'account_management_edit'}
      },
      {
        path: "/members/account/commission/transfer",
        name: "members.account.commission.transfer",
        component: CommissionTransfer,
        // meta: { permission: 'account_management_edit'}
      },
    ]
  },


  {
    path: "/chart-of-accounts",
    component: ChartOfAccounts,
    children: [{
        path: "/chart-of-accounts",
        name: "chart_of_accounts.index",
        component: ChartOfAccountsIndex,
        meta: {
          permission: 'financial_management_view_coa'
        }
      },
      {
        path: "/chart-of-accounts/account-types",
        name: "account_types.index",
        component: AccountTypes,
        meta: {
          permission: 'financial_management_view_coa_type'
        }

      },
      {
        path: "/chart-of-accounts/import",
        name: "coa.import",
        component: COAImports,
        meta: {
          permission: 'financial_management_import_coa'
        }

      },
      {
        path: "/chart-of-accounts/reconcile",
        name: "coa.reconcile",
        component: Main,
        meta: {
          permission: 'financial_management_import_coa'
        }

      },
      {
        path: "/chart-of-accounts/merge-coa",
        name: "coa.merge",
        component: MergeCOA,
        meta: {
          permission: 'financial_management_import_coa'
        }

      },
      {
        path: "/chart-of-accounts/transactions",
        name: "coa.transactions",
        component: COATransaction,
        meta: {
          permission: 'financial_management_coa_transaction'
        }

      },
      // {
      //   path: "/chart-of-accounts/sub/import",
      //   name: "coasub.import",
      //   component: COASubImports
      // },
      // {
      //   path: "/users/create",
      //   name: "users.create",
      //   component:  UserCreate
      // }
    ]
  },
  {
    path: "/institution",
    component: InstitutionManagement,
    children: [{
      path: "/institution",
      name: "institution.edit",
      component: InstitutionCreate,
      meta: {
        permission: 'system_management_view_institution'
      }


    }, ]
  },
  {
    path: "/financial-year",
    component: FinancialYearManagement,
    children: [{
      path: "/financial-year",
      name: "financial-year.index",
      component: FinancialYear,
      meta: {
        permission: 'system_management_view_financial_year'
      }
    }, ]
  },

  {
    path: "/loan",
    component: LoanManagement,
    children: [{
        path: "/loans/application",
        name: "loans.application",
        component: LoanApplication,
        meta: {
          permission: 'loan_management_add'
        }
      },
      {
        path: "/loans/transactions",
        name: "loans.transactions",
        component: AllLoanTransactions,
        meta: {
          permission: 'loan_management_add'
        }
      },
      {
        path: "/loans/calculator",
        name: "loans.calculator",
        component: LoanCalculator,
        meta: {
          permission: 'loan_management_calculator'
        }
      },
      {
        path: "/loans/repayments",
        name: "loans.repayments",
        component: AllLoanRepayments,
        meta: {
          permission: 'loan_management_repayment'
        }
      },

      {
        path: "/loans/scheme",
        name: "loans.scheme",
        component: LoanScheme,
        meta: {
          permission: 'loan_management_view_scheme'
        }
      },

      {
        path: "/loans/scheme/create",
        name: "loans.scheme.create",
        component: SchemeCreate,
        meta: {
          permission: 'loan_management_add_scheme'
        }
      },
      {
        path: "/loans/scheme/:id/edit",
        name: "loans.scheme.edit",
        component: SchemeEdit,
        meta: {
          permission: 'loan_management_edit_scheme'
        }
      },
      {
        path: "/loans",
        name: "loan.index",
        component: LoanIndex,
        meta: {
          permission: 'loan_management_view'
        }

      },
      {
        path: "/loans/merge",
        name: "loan.merge",
        component: LoanMerge,
        meta: {
          permission: 'loan_management_view'
        }
      },
      {
        path: "/loans/import",
        name: "loan.import",
        component: LoanImports,
        meta: {
          permission: 'loan_management_import'
        }

      },
      // {
      //   path: "/loans/bulk/repayments/upload",
      //   name: "loan.bulk.repayments.upload",
      //   component: BulkRepaymentUpload,

      // },

      // {
      //   path: "/loan-application/create",
      //   name: "loan.application.create",
      //   component: CreateLoanApplication
      // },
    ]
  },
  {
    path: "/voucher",
    component: VoucherManagement,
    children: [{
        path: "/voucher",
        name: "voucher",
        component: VoucherIndex,
        meta: {
          permission: 'voucher_management_view'
        }
      },
      {
        path: "/voucher/create",
        name: "voucher.create",
        component: VoucherCreate,
        meta: {
          permission: 'voucher_management_add'
        }
      },
      {
        path: "/voucher/:id/edit",
        name: "voucher.edit",
        component: VoucherEdit,
        meta: {
          permission: 'voucher_management_edit'
        }
      },
      {
        path: "/voucher/approve/:id",
        name: "voucher.approve",
        component: ApproveVoucher,
        meta: {
          permission: 'voucher_management_approve'
        }

      }
    ]
  },
  {
    path: "/journal",
    component: JournalManagement,
    children: [{
        path: "/journal",
        name: "journal",
        component: JournalIndex,
        meta: {
          permission: 'journal_management_view'
        }
      },
      {
        path: "/journal/create",
        name: "journal.create",
        component: JournalCreate,
        meta: {
          permission: 'journal_management_add'
        }
      },
      {
        path: "/journal/create-opening-closing",
        name: "journal.create-opening-closing",
        component: CreateOpeningAndClosingJournal,
        meta: {
          permission: 'journal_management_add'
        }
      },
      {
        path: "/journal/:id/edit",
        name: "journal.edit",
        component: JournalEdit,
        meta: {
          permission: 'journal_management_edit'
        }
      },
      {
        path: "/journal/approve/:id",
        name: "journal.approve",
        component: ApproveJournal,
        meta: {
          permission: 'journal_management_approve'
        }
      },
      {
        path: "/journal/transfer",
        name: "journal.transfer",
        component: JournalTransfer,
        meta: {
          permission: 'journal_management_transfer'
        },
      },
      {
        path: "/journal/transfer/create",
        name: "journal.transfer.create",
        component: JournalTransferCreate,
      },
      {
        path: "/journal/import",
        name: "journal.import",
        component: ImportPage,
      },
    ]
  },
  {
    path: "/transactions",
    component: TransactionManagement,
    children: [{
        path: "/transactions/deposit",
        name: "transactions.deposit",
        component: Deposit,
        meta: {
          permission: 'transaction_management_deposit'
        }
      },
      {
        path: "/transactions/withdrawal",
        name: "transactions.withdrawal",
        component: Withdrawal,
        meta: {
          permission: 'transaction_management_withdrawal'
        }
      },
      // {
      //   path: "/transactions/deposit-withdrawal",
      //   name: "transactions.deposit-withdraw",
      //   component: DepositWithdrawal
      // },
      // {
      //   path: "/transactions/deposits/bulk",
      //   name: "transactions.bulk-deposit-withdraw",
      //   component: BulkDeposits
      // },
      // {
      //   path: "/transactions/withdrawals/bulk",
      //   name: "transactions.withdrawals.bulk",
      //   component: BulkWithdrawals
      // },
      {
        path: "/transactions/all-deposit-withdrawal",
        name: "transactions.all-deposit-withdraw",
        component: AllDepositWithdrawal,
        meta: {
          permission: 'transaction_management_all_view'
        },
      },
      {
        path: "/transactions/cheque-processing",
        name: "transactions.cheque-processing",
        component: ChequeProcessing,
        meta: {},
      },
      {
        path: "/transactions/imports",
        name: "transactions.imports",
        component: TransactionImport,
        meta: {
          permission: 'transaction_management_import'
        },
      },

      {
        path: "/mobile/deposit",
        name: "mobile.deposit",
        component: MobileDeposit,
        meta: {
          permission: 'transaction_management_deposit'
        }
      },
      {
        path: "/mobile/loan-repayment",
        name: "mobile.loan-repayment",
        component: LoanRepayment,
        meta: {
          permission: 'transaction_management_loan_repayment'
        }
      },
      {
        path: "/mobile/all-members",
        name: "mobile.all-members",
        component: AllMembers,
        meta: {
          permission: 'transaction_management_deposit'
        }
      },
      {
        path: "/mobile/other-receipt",
        name: "mobile.other-receipt",
        component: OtherReceipt,
        meta: {
          permission: 'transaction_management_deposit'
        }
      },
      {
        path: "/mobile/withdrawal",
        name: "mobile.withdrawal",
        component: MobileWithdrawal,
        meta: {
          permission: 'transaction_management_withdrawal'
        }
      },
      {
        path: "/mobile/history",
        name: "mobile.history",
        component: History
      },
      {
        path: "/mobile/profile",
        name: "mobile.profile",
        component: MobileProfile
      },
    ]
  },
  {
    path: "/other-receipt-payment",
    component: OtherReceiptPaymentManagement,
    children: [{
        path: "/other-receipt-payment",
        name: "other.receipt.payment",
        component: OtherReceiptPaymentIndex
      },
      {
        path: "/other-receipt-payment/create",
        name: "other.receipt.payment.create",
        component: CreateOtherReceiptPayment
      },
    ]
  },


  {
    path: "/investment/fixed-deposit",
    name: "investment.fixed-deposit",
    component: FixedDeposit,
    meta: {
      permission: 'operation_management_fixed_deposit_view'
    },
  },
  {
    path: "/investment/fixed-deposit/transactions",
    name: "investment.fixed-deposit.transactions",
    component: FixedDepositTransactions,
    meta: {
      permission: 'operation_management_fixed_deposit_view'
    },
  },
  {
    path: "/investment/fixed-deposit-scheme",
    name: "investment.fixed-deposit.scheme",
    component: FixedDepositScheme,
    meta: {
      permission: 'operation_management_fixed_deposit_view'
    },

  },
  {
    path: "/fixed-deposit/scheme/create",
    name: "investment.fixed-deposit.scheme.create",
    component: FdCreateScheme,
    meta: {
      permission: 'operation_management_fixed_deposit_add'
    },
  },
  {
    path: "/fixed-deposit/scheme/:id/edit",
    name: "fixed-deposit.scheme.edit",
    component: FdEditScheme,
    meta: {
      permission: 'operation_management_fixed_deposit_edit'
    },
  },
  {
    path: "/standing-order",
    name: "standing-order",
    component: StandingOrder,
    meta: {
      permission: 'operation_management_standing_order_view'
    },
  },
  {
    path: "/operations/imports",
    name: "operations.imports",
    component: OperationImport,
    meta: {
      permission: 'operation_management_import'
    },
  },
  {
    path: "/reports",
    name: "reports",
    component: ReportsManagement,
    children: [{
        path: "/reports",
        name: "reports.index",
        component: Reports
      },
      {
        path: "/reports/trial-balance",
        name: "reports.trial_balance",
        component: TrialBalYearToDate
      },
      {
        path: "/reports/coa",
        name: "reports.coa",
        component: ChartOfAccountReport
      },

      {
        path: "/reports/financials/single-coa",
        name: "reports.single_coa",
        component: SingleChartOfAccountReport
      },
      {
        path: "/reports/financials/coa/heads/summary",
        name: "reports.coa_heads.summary",
        component: COAHeadsReport
      },
      {
        path: "/reports/financials/receipts-payments",
        name: "reports.finance.receipts_payments",
        component: ReceiptsPayments
      },
      {
        path: "/reports/financials/receipts/members",
        name: "reports.finance.receipts.customers",
        component: DetailedCustomerReceiptsReport
      },
      {
        path: "/reports/financials/payments/members",
        name: "reports.finance.payments.customers",
        component: DetailedCustomerPaymentsReport
      },
      {
        path: "/reports/financials/balance-sheet/vertical",
        name: "reports.balance_sheet.vertical",
        component: BalanceSheetDetailedVertical
      },
      {
        path: "/reports/financials/balance-sheet/horizontal",
        name: "reports.balance_sheet.horizontal",
        component: BalanceSheetDetailedHorizontal
      },
      {
        path: "/reports/financials/balance-sheet/summary/horizontal",
        name: "reports.balance_sheet.summary",
        component: BalanceSheetSummaryHorizontal
      },
      {
        path: "/reports/financials/balance-sheet/summary/vertical",
        name: "reports.balance_sheet.summary.vertical",
        component: BalanceSheetSummaryVertical
      },
      {
        path: "/reports/financials/income-statement",
        name: "reports.income_statement",
        component: IncomeStatement
      },
      {
        path: "/reports/financials/income-statement/summary",
        name: "reports.income_statement.summary",
        component: IncomeStatementSummary
      },
      {
        path: "/reports/financials/birthday",
        name: "reports.financials.birthday",
        component: CustomerBirthday
      },
      {
        path: "/reports/products/customers",
        name: "reports.daily_products_customers",
        component: DailyProductsCustomers
      },
      {
        path: "/reports/products/customers/ro",
        name: "reports.daily_products_customers_ro",
        component: DailyProductsCustomersbyRo
      },
      {
        path: "/reports/customer/control/balance",
        name: "reports.customer_control_balance",
        component: CustomerControlBalance
      },
      {
        path: "/reports/member/statistic",
        name: "reports.member_statistic",
        component: MemberStatisticReport
      },
      {
        path: "/reports/product/balance/term",
        name: "reports.product_balance_term",
        component: ProductBalanceTerm
      },
      {
        path: "/reports/customer/listing",
        name: "reports.customer_listing",
        component: CustomerListing
      },
      {
        path: "/reports/performance/analysis",
        name: "reports.performance_analysis",
        component: Performance
      },
      {
        path: "/reports/aging",
        name: "reports.aging",
        component: Aging
      },
      {
        path: "/reports/loan/product",
        name: "reports.loan.product",
        component: LoanProduct
      },
      {
        path: "/reports/loan/product/detailed",
        name: "reports.loan.product.detailed",
        component: LoanProductDetailed
      },
      {
        path: "/reports/loan/delinquent/product",
        name: "reports.loan.delinquent.product",
        component: LoanDelinquentByProduct
      },
      {
        path: "/reports/loan/repayment",
        name: "reports.loan_repayment",
        component: LoanRepay
      },
      {
        path: "/reports/loans/expected-repayments",
        name: "reports.expected_loan_repayment",
        component: ExpectedLoanRepayments
      },
      {
        path: "/reports/loan/disbursed",
        name: "reports.loan_disbursed",
        component: LoanDisbursed
      },
      {
        path: "/reports/delinquency",
        name: "reports.delinquency",
        component: Delinquency
      },
      {
        path: "/reports/aging/summary",
        name: "reports.aging.summary",
        component: LoanAgingSummary
      },
      {
        path: "/reports/open/close",
        name: "reports.open_close",
        component: OpenClose
      },
      {
        path: "/reports/account/statistics/cua",
        name: "reports.account_statistics.cua",
        component: AccountStatisticCUA
      },
      {
        path: "/reports/account/statistics/cua/summary",
        name: "reports.brief.account_statistics.summary",
        component: AccountStatisticCUASummary
      },

      {
        path: "/reports/account/statistic/system",
        name: "reports.statistic.system",
        component: AccountStatisticSystem
      },
      {
        path: "/reports/account/statistic/system/summary",
        name: "reports.statistic.system.summary",
        component: AccountStatisticSystemSummary
      },

      {
        path: "/reports/receipt-payment/summary",
        name: "reports.receipt_payment_summary",
        component: ReceiptPaymentSummary
      },
      {
        path: "/reports/receipt-payment/detailed",
        name: "reports.receipt_payment_detailed",
        component: DetailedReceiptAndPayment
      },

      {
        path: "/reports/detailed/receipt",
        name: "reports.detailed_receipt",
        component: DetailedReceipt
      },
      {
        path: "/reports/detailed/payment",
        name: "reports.detailed_payment",
        component: DetailedPayment
      },
      {
        path: "/reports/voucher",
        name: "reports.voucher",
        component: VoucherReport
      },
      {
        path: "/reports/journal",
        name: "reports.journal",
        component: JournalReport
      },
      {
        path: "/reports/fixed-term-deposits",
        name: "reports.fixed_term_deposits",
        component: FixedTermDepositReport
      },
      {
        path: "/reports/fixed-term-transactions",
        name: "reports.fixed_term_transactions",
        component: FixedTermTransactionsReport
      },
      {
        path: "/reports/controls/user-coa-tracker",
        name: "reports.user_coa_tracker",
        component: UserCoaTracker
      },
      {
        path: "/reports/controls/consolidated/performance",
        name: "reports.controls.consolidated.performance",
        component: ConsolidatedPerformance
      },
      {
        path: "/reports/controls/single/consolidated/performance",
        name: "reports.controls.single.consolidated.performance",
        component: SingleConsolidatedPerformance
      },
      {
        path: "/reports/controls/single/commission/paid",
        name: "reports.controls.single.commission.paid",
        component: SingleCommissionRoPaid
      },
      {
        path: "/reports/controls/single/commission/expected",
        name: "reports.controls.single.commission.expected",
        component: SingleCommissionRoExpected
      },
      {
        path: "/reports/controls/ro/commission/summary",
        name: "reports.controls.ro.commission.summary",
        component: RoCommissionSummary
      },
      {
        path: "/reports/controls/customer/monthly/balance",
        name: "reports.controls.customer.monthly.balance",
        component: CustomerBalanceDifferences
      },
      // {
      //   path: "/reports/detailed/receiptandpayment",
      //   name: "reports.detailed_receipt_and_payment",
      //   component: DetailedReceiptAndPayment
      // },

      {
        path: "/reports/receipt-payment/system/default/summary",
        name: "reports.receipt.payment.system.summary",
        component: ReceiptPaymentDefaultSummary
      },
      {
        path: "/reports/receipt-payment/system/default/detailed",
        name: "reports.receipt.payment.system.detailed",
        component: ReceiptPaymentDefaultDetailed
      },
    ]
  },
  {
    path: "/settings/generate/apikey",
    name: 'apikey.index',
    component: ApikeyIndex,
    meta: {
      permission: 'financial_management_api_key'
    },
  },
  {
    path: "/settings/excel/export",
    name: 'excel.export',
    component: ExcelExport,
    // meta: { permission: 'financial_management_api_key' },
  },
  {
    path: "/settings/sms",
    name: 'settings.sms',
    component: SmsIndex,
    // meta: { permission: 'financial_management_api_key' },
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized
  },
  // AI features routes can be added here
  {
    path: "/ai/documentUpload",
    name: 'ai.documentUpload',
    component: DocumentUpload,
    // meta: { permission: 'financial_management_api_key' },
  },

]